import {
  SET_TASK_GROUP,
  SET_DETAIL_IMG_MESSAGE,
  SET_CONFIG_FILE,
  SET_MULTI_FRAME_CONFIG_FILE,
  IS_MULTI_FRAME,
  SET_JIGSAW_PREVIEW,
  SET_FRAME_STATISTIC_MESSAGE,
  SET_TASK_SCENE_TYPE,
} from './mutation-types'
import api from '@/api'
import { IS_DAYANCLOUD } from '@/utils/const'

const state = {
  groups: [],
  imgMessage: {
    imgUrl: '',
    imgName: '',
  },
  configList: {},
  multiFrameConfigList: {},
  isMultiFrame: false,
  jigsawPreview: false,
  frameTips: {},
  sceneType: '',
}

const mutations = {
  [SET_TASK_GROUP] (state, payload) {
    state.groups = payload
  },
  [SET_DETAIL_IMG_MESSAGE] (state, payload) {
    state.imgMessage = payload
  },
  [SET_CONFIG_FILE] (state, payload) {
    state.configList = payload
  },
  [SET_MULTI_FRAME_CONFIG_FILE] (state, payload) {
    state.multiFrameConfigList = payload
  },
  [IS_MULTI_FRAME] (state, payload) {
    state.isMultiFrame = payload
  },
  [SET_JIGSAW_PREVIEW] (state, payload) {
    state.jigsawPreview = payload
  },
  [SET_FRAME_STATISTIC_MESSAGE] (state, payload) {
    state.frameTips = payload
  },
  [SET_TASK_SCENE_TYPE] (state, payload) {
    state.sceneType = payload
  },
}

const actions = {
  // 删除作业
  async deleteTask({ state }, payload) {
    const data = await api.dayanTaskApi.deleteTask(payload)
    return data
  },
  // 增加约束
  async addConstraints({ state }, payload) {
    let param = {
      ...payload.query,
    }
    const { result, message, code } = await api.dayanTaskApi.addConstraints(param)
    return { result, message, code }
  },
  // 删除约束
  async deleteConstraints({ state }, payload) {
    let param = {
      ...payload.query,
    }
    const { result, message, code } = await api.dayanTaskApi.deleteConstraints(param)
    return { result, message, code }
  },
  // 获取属性要求约束群组（单个任务）
  async renderingGetSingleStrategyForDataBase ({state}, payload) {
    let param = {
      ...payload,
    }
    const {data} = await api.dayanTaskApi.renderingGetSingleStrategyForDataBase(param)
    return data
  },
  // 重提
  async restartTask ({state}, payload) {
    let param = {
      ...payload,
    }
    const data = await api.dayanTaskApi.restartTask(param)
    return data
  },
  // 设置超时停止时间
  async setTaskOverTimeStop({ state }, payload) {
    const data = await api.dayanTaskApi.setTaskOverTimeStop(payload)
    return data
  },
  // 恢复作业
  async regainTask({ state }, payload) {
    const data = await api.dayanTaskApi.regainTask(payload)
    return data
  },
  // 增加群组
  async addCategory({ state }, payload) {
    let param = {
      ...payload.query,
    }
    const { result, message, code } = await api.dayanTaskApi.addCategory(param)
    return { result, message, code }
  },
  // 删除群组
  async deleteCategory({ state }, payload) {
    let param = {
      ...payload.query,
    }
    const { result, message, code } = await api.dayanTaskApi.deleteCategory(param)
    return { result, message, code }
  },
  // 查询所有群组
  async queryCategory({ commit, state }) {
    if (state.groups.length > 0) return false
    const { data } = await api.dayanTaskApi.queryCategory({})
    commit(SET_TASK_GROUP, data)
  },
  // 新增管理员标签
  async addAdminLabel ({commit}, payload) {
    const {code, message} = await api.dayanTaskApi.addAdminLabel(payload)
    return {code, message}
  },
  // 删除管理员标签
  async deleteAdminLabel ({commit}, payload) {
    const {code, message} = await api.dayanTaskApi.deleteAdminLabel(payload)
    return {code, message}
  },
  // 获取管理员标签
  async getAdminLabel ({commit}, payload) {
    const {data, code, message} = await api.dayanTaskApi.getAdminLabel(payload)
    return {data, code, message}
  },
  // 给任务添加标签
  async addTaskAdminLabel ({commit}, payload) {
    const {code, message} = await api.dayanTaskApi.addTaskAdminLabel(payload)
    return {code, message}
  },
  // 分析设置超时停止时间
  async analysisSetTaskOverTimeStop ({state}, payload) {
    const data = await api.dayanTaskApi.analysisSetTaskOverTimeStop(payload)
    return data
  },
  // 预处理停止
  async stopPreTask ({commit, state}, taskIds) {
    let param = {
      taskIds: taskIds,
    }
    const {result, message, code} = await api.dayanTaskApi.stopPreTask(param)
    return {result, message, code}
  },
  // 预处理设置超时停止时间
  async preSetTaskOverTimeStop ({state}, payload) {
    const data = await api.dayanTaskApi.preSetTaskOverTimeStop(payload)
    return data
  },
  // 获取空三日志详情
  async getSky3Log ({commit}, payload) {
    const {code, data} = await api.dayanTaskApi.getSky3Log(payload)
    return code === 200 ? data : []
  },
  // 获取重建日志详情
  async getRebuildLog ({commit}, payload) {
    const {code, data} = await api.dayanTaskApi.getRebuildLog(payload)
    return code === 200 ? data : []
  },
  // 查看历史重渲记录
  async getHistoryRenderInfo ({commit}, payload) {
    const {data} = await api.dayanTaskApi.getHistoryRenderInfo(payload)
    if (data === 'MUNU_NO_RESOURCES') return []
    return data
  },
  // 帧任务详情
  // 帧详情任务列表
  async getTaskFrameRenderList ({commit}, payload) {
    const {data, code} = await api.dayanTaskApi.getTaskFrameRenderList(payload)
    if (code === 200) return data
    return {}
  },
  // 增加属性
  async renderingAddProperties ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.dayanTaskApi.renderingAddProperties(param)
    return {result, message, code}
  },
  // 删除属性
  async renderingDeleteProperties ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.dayanTaskApi.renderingDeleteProperties(param)
    return {result, message, code}
  },
  // 增加要求
  async renderingAddRequirements ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.dayanTaskApi.renderingAddRequirements(param)
    return {result, message, code}
  },
  // 删除要求
  async renderingDeleteRequirements ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.dayanTaskApi.renderingDeleteRequirements(param)
    return {result, message, code}
  },
  // 获取频率调度
  async getFrequencyControl ({state}, payload) {
    let param = {
      ...payload,
    }
    const {data} = await api.dayanTaskApi.getFrequencyControl(param)
    return data
  },
  // 设置频率调度
  async setFrequencyControl ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.dayanTaskApi.setFrequencyControl(param)
    return {result, message, code}
  },
  // 批量修改频率调度
  async updateFrequency ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.dayanTaskApi.updateFrequency(param)
    return {result, message, code}
  },
  // 查看日志
  // eslint-disable-next-line
  async setPreHandleLogDetails ({}, {renderingType, render, munu, pageSize, pageNum}) {
    if (renderingType === 'munuLog') {
      const {data} = await api.dayanTaskApi.getPerMunuLog({
        ...munu,
        pageSize,
        pageNum,
      })
      return data
    } else {
      const {data} = await api.dayanTaskApi.getPreHandleLog({
        ...render,
        renderingType,
        pageSize,
        pageNum,
      })
      return data
    }
  },
  // 帧任务详情
  // 帧详情任务列表
  // eslint-disable-next-line
  async getTaskFrameRenderList ({commit}, payload) {
    const {data} = await api.dayanTaskApi.getTaskFrameRenderList(payload)
    return data
  },
  // 扣费记录
  async getTaskFrameConsumeInfo ({commit}, payload) {
    const data = await api.dayanTaskApi.getTaskFrameConsumeInfo(payload)
    return data
  },
  // 查询帧耗时分布图以及帧完成情况
  // eslint-disable-next-line
  async getFrameCondition ({}, payload) {
    const {data} = await api.dayanTaskApi.getFrameCondition(payload)
    return data
  },
  // 查询配置详情
  // eslint-disable-next-line
  async loadingTaskParameter({commit}, payload) {
    const {data} = await api.dayanTaskApi.loadingTaskParameter(payload)
    const {sceneName} = data
    const sceneType = sceneName && sceneName.match(/(?!=\.)[^.]+$/g)
    commit(SET_TASK_SCENE_TYPE, sceneType ? sceneType[0] : '')
    return {
      ...data,
      taskParam: data.taskParam || [],
    }
  },
  // 查询配置文档
  // eslint-disable-next-line
  async getTaskJson ({}, payload) {
    const {data} = await api.dayanTaskApi.getTaskJson(payload)
    return data
  },
  // 加载帧的缩略图
  // eslint-disable-next-line
  async loadingTaskThumbnail({}, payload) {
    const data = await api.dayanTaskApi.loadingTaskThumbnail(payload)
    return data
  },
  // 加载帧的截图
  // eslint-disable-next-line
  async loadingTaskGrab({}, payload) {
    const data = await api.dayanTaskApi.loadingTaskGrab(payload)
    return data
  },
  // 重提帧任务
  // eslint-disable-next-line
  async recommitTaskFrame ({}, payload) {
    const data = await api.dayanTaskApi.recommitTaskFrame(payload)
    return data
  },
  // 停止帧任务
  // eslint-disable-next-line
  async stopTaskFrame ({}, payload) {
    const data = await api.dayanTaskApi.stopTaskFrame(payload)
    return data
  },
  // 开始帧任务
  // eslint-disable-next-line
  async startTaskFrame ({}, payload) {
    const data = await api.dayanTaskApi.startTaskFrame(payload)
    return data
  },
  setDetailImgMessage ({commit}, payload) { //
    commit(SET_DETAIL_IMG_MESSAGE, payload)
  },
  // 查询生产预览url路径
  async getTaskCesium3DTilesUrl ({commit}, payload) {
    const data = await api.dayanTaskApi.getTaskCesium3DTilesUrl(payload)
    return data
  },
  // 获取任务帧总数及费用//
  async getSumFrameConsume ({commit}, payload) {
    const {data} = await api.dayanTaskApi.getSumFrameConsume(payload)
    return data
  },
  // 查询配置文档名称
  async getJsonFileName ({commit}, payload) {
    const { data } = await api.dayanTaskApi.getJsonFileName(payload)
    var frameFile = Object.entries(data).filter(k => !/.*(json|txt|cfg|org)$/g.test(k))
    if (frameFile.length > 0) {
      var jsonFile = Object.entries(data).filter(k => /.*(json|txt|cfg|org)$/g.test(k))
      var jsonFileDict = {}
      var frameFileDict = {}
      jsonFile.forEach(j => {
        jsonFileDict[j[0]] = j[1]
      })
      frameFile.forEach(f => {
        // var key = f[0].match(/(?!.*_).*/g)[0]
        var result = f[0].match(/_([^_]*)/g)
        if (result && (IS_DAYANCLOUD ? result.length > 2 : true)) {
          var keyMunuId = result[0].replace('_', '')
          var keyFrame = result[2].replace('_', '')
          var key = `${keyMunuId}#${keyFrame}`
          frameFileDict[key] = f[1]
        }
      })
      commit(SET_CONFIG_FILE, jsonFileDict)
      commit(SET_MULTI_FRAME_CONFIG_FILE, frameFileDict)
    } else {
      commit(SET_CONFIG_FILE, data)
      commit(SET_MULTI_FRAME_CONFIG_FILE, {})
    }
    return data
  },
  // 判断任务是否一机多帧
  isMultiFrameInOneMechine ({commit}, payload) {
    commit(IS_MULTI_FRAME, payload)
  },
  // 判断是否提供拼接预览功能
  isProvidedJigsawPreview ({commit}, payload) {
    commit(SET_JIGSAW_PREVIEW, payload)
  },
  // 获取帧详情列表的帧统计信息
  async getFrameStatisticMessage ({commit}, payload) {
    const {data} = await api.dayanTaskApi.getFrameStatisticMessage(payload)
    commit(SET_FRAME_STATISTIC_MESSAGE, data)
  },
  // 获取用户输入输出路径
  async getOutOrInputPath ({commit}, payload) {
    const data = await api.dayanTaskApi.getOutOrInputPath(payload)
    return data
  },
  // 查询账户信息
  async queryAccountInfo ({commit}, payload) {
    const {data, result} = await api.dayanTaskApi.queryAccountInfo(payload)
    return {data, result}
  },
  // 内存信息
  async advanceParameterSetting ({commit}, payload) {
    const {data, result, code, message} = await api.dayanTaskApi.advanceParameterSetting(payload)
    return {data, result, code, message}
  },
  // 获取任务关联工单
  async getJiraIssues ({commit}, payload) {
    const {code, data} = await api.dayanTaskApi.getJiraIssues(payload)
    return {code, data}
  },
  // 修改备注按钮
  async updateRemark ({commit}, payload) {
    const data = await api.dayanTaskApi.updateRemark(payload)
    return data
  },
  // 查询空三预览url路径
  async getTaskPointCloudDataUrl ({commit}, payload) {
    const data = await api.dayanTaskApi.getTaskPointCloudDataUrl(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
